// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_ZfB","cls2":"CiterightInline-cls2_i_n CiterightInline-cls1_ZfB"};